module.exports = __webpack_public_path__ + "static/img/lxwm_banner.ff8d016.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lxwm_banner.png
// module id = RTga
// module chunks = 0